import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {HttpClient} from '@angular/common/http';
import {Component, ElementRef, NgZone, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MapsAPILoader} from '@agm/core';
import {ChangeDetectorRef} from '@angular/core';
import {MatDialog} from '@angular/material';
import {ControllerDialogComponent} from '@app/app/controller/controller-dialog';
import {AWSService} from '@app/app/shared/services/aws.service';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/expand';
import 'rxjs/add/operator/last';
import 'rxjs/add/observable/empty';
import {environment} from '@app/environments/environment';
import {UpdateControllerDialogComponent} from '@app/app/controller/update.controller.dialog.component';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {Subscription} from 'rxjs/Subscription';
import {ProvisionControllerDialogComponent} from '@app/app/controller/provision.controller.dialog.component';
import {ToggleLedDialogComponent} from '@app/app/controller/toggle.led.dialog.component';
// import * as AWS from 'aws-sdk';
// import * as awsIot from 'aws-iot-device-sdk';

@Component({
  moduleId: module.id,
  selector: 'table-sorting-example',
  templateUrl: 'controller.component.html',
  styleUrls: ['controller.css']
})

export class ControllerComponent implements OnInit, OnDestroy {
  mode: string;
  clients = [];
  public success = '';
  public error = '';
  public connected = null;

  public viewPark = {
    name: '',
    address: '',
    projectId: '',
    installation_type: '',
    clientId: null,
    clientNames: [],
    iccid: '',
    active: false,
    is_provisioned: false,
    parkId: '',
  };
  controllerId;
  public parkId = '';
  coords = {lat: 0, lon: 0};
  public addControllerForm: FormGroup;
  public inProgress = false;
  public zoom = 3;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  cou = 0;
  patchRunning = false;
  updateRunning = false;
  deleteRunning = false;
  public isAdmin = false;
  private parkUrl = '';
  public command = '';
  public isSendingCommand = false;
  private commandId;
  private mqttTopic;
  public log = '';

  @ViewChild('addressAutocomplete') public addressAutocompleteEl: ElementRef;

  constructor(private http: HttpClient, private route: ActivatedRoute, private auth: AuthenticationService,
              private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, private router: Router,
              private changeDetector: ChangeDetectorRef, public dialog: MatDialog, private aws: AWSService,
              public updateDialog: MatDialog, public provisionDialog: MatDialog, private comm: CommandsService, private urlHelper: UrlHelper) {
    this.isAdmin = (this.auth.userRole() === 'admin');
  }

  private reloadShadow() {
    this.http.get(this.prepareParkUrl()).subscribe((data: { data: any, included: any[] }) => {
      this.connected = this.isOnline(this.spl(data.data.attributes.shadow)) || this.isProvisioning(data.data.attributes);

      this.viewPark.is_provisioned = data.data.attributes.is_provisioned;
    });
  }

  private spl(shadow) {
    if (shadow !== null && shadow.hasOwnProperty('splashpad')) {
      return shadow.splashpad;
    }

    return {};
  }

  public isProvisioning(attributes) {
    if (!attributes.hasOwnProperty('is_connected')) {
      return false;
    }

    return Boolean(attributes.is_connected);
  }

  public isOnline(splashpad) {
    if (!splashpad.hasOwnProperty('last_connection')) {
      return false;
    }

    if (!splashpad.hasOwnProperty('last_disconnection')) {
      return true;
    }

    return Number.parseInt(splashpad.last_connection) > Number.parseInt(splashpad.last_disconnection);
  }

  private getRoleUrl() {
    let role = '';

    if (this.auth.userRole() === 'manufacturer') {
      role = 'manufacturers';
    } else if (this.auth.userRole() === 'client') {
      role = 'clients';
    } else if (this.auth.userRole() === 'admin') {
      role = 'admins';
    } else if (this.auth.userRole() === 'employee') {
      role = 'employees';
    }

    return role;
  }

  private prepareShadowUrl() {
    return `/${this.getRoleUrl()}/${this.auth.userId()}/parks/${this.controllerId}/shadow`;
  }

  private prepareParkUrl() {
    return `/${this.getRoleUrl()}/${this.auth.userId()}/parks/${this.controllerId}`;
  }

  private prepareProvisionUrl() {
    return `/${this.getRoleUrl()}/${this.auth.userId()}/parks/${this.controllerId}/provision`;
  }

  private prepareToggleLedUrl() {
    return `/${this.getRoleUrl()}/${this.auth.userId()}/parks/${this.controllerId}/toggle-led`;
  }

  private prepareParksUrl() {
    return `/${this.getRoleUrl()}/${this.auth.userId()}/parks`;
  }

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
  }

  public setCommand(event) {
    try {
      this.command = event.target.value;
    } catch (e) {
      // console.log('could not set value');
    }
  }

  public sendCommand() {
    if (this.command) {
      this.isSendingCommand = true;

      if (!this.commandId) {
        this.commandId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      }

      if (!this.sub2) {
        this.mqttTopic = `${this.parkId}/system/${this.commandId}`;

        this.aws.connect2().subscribe((conn) => {
          this.sub2 = this.aws.messagesObservable.subscribe((msg) => {
            if (msg.topic === this.mqttTopic) {
              let message = '';

              if (msg.message.hasOwnProperty('params')) {
                message = '>>> ' + msg.message.params;
              }

              if (msg.message.hasOwnProperty('result')) {
                message = '<<< ' + msg.message.result;
              }

              if (message) {
                this.log += (message + '\n');
              }
            }
          });

          conn.subscribe(this.mqttTopic, {qos: 1}, (err1, granted) => {
            this.comm.sendRaw(this.controllerId, this.command, this.mqttTopic).subscribe((res) => {
              this.isSendingCommand = false;
            }, (err2) => {
              this.isSendingCommand = false;
            });
          });
        });
      } else {
        this.comm.sendRaw(this.controllerId, this.command, this.mqttTopic).subscribe((res) => {
          this.isSendingCommand = false;
        }, (err2) => {
          this.isSendingCommand = false;
        });
      }
    }
  }

  retrieveClients() {
    return this.http.get(`/clients?page=1`).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(`/clients?page=${nextPage}`);
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }

  ngOnInit() {
    this.sub3 = this.route.params.subscribe(params => {
      this.retrieveClients().subscribe((res) => {
        this.clients = res;
      });

      if (params.id === 'new') {
        this.mode = 'create';
      } else {
        // Run cache refresh each 7 seconds
        this.sub1 = TimerObservable.create(7000, 7000).subscribe(() => {
          this.reloadShadow();
        });

        this.mode = 'view';
        this.controllerId = params.id;

        this.http.get(this.prepareParkUrl()).subscribe((data: { data: any, included: any[] }) => {
          let location: any = {};
          const clients = [];

          (data.included || []).forEach((inc) => {
            if (inc.type === 'Location') {
              location = inc;
              this.coords.lat = parseFloat(location.attributes.latitude);
              this.coords.lon = parseFloat(location.attributes.longitude);
              this.zoom = 12;
            }
            if (inc.type === 'Clients') {
              clients.push(inc);
              this.parkUrl = `${inc.links.self}${data.data.links.self}`;
            }
          });

          this.parkId = data.data.attributes.park_id || null;

          this.connected = this.isOnline(this.spl(data.data.attributes.shadow)) || this.isProvisioning(data.data.attributes);

          this.initView(data, location, clients);

          this.addControllerForm.patchValue({
            name: data.data.attributes.name,
            address: location.attributes ? location.attributes.address : '',
            projectId: data.data.attributes.project_id,
            installation_type: data.data.attributes.installation_type || 'FT',
            clientId: this.viewPark.clientId || null,
            iccid: data.data.attributes.iccid,
          });
        });
      }

      this.addControllerForm = new FormGroup({
        clientId: new FormControl(null),
        name: new FormControl('', [Validators.required, Validators.minLength(5)]),
        address: new FormControl('', [Validators.required, Validators.minLength(10)]),
        projectId: new FormControl('', [Validators.required, Validators.minLength(5)]),
        installation_type: new FormControl('FT', [Validators.required]),
        iccid: new FormControl(''),
      });

      if (this.mode === 'create') {
        this.runAutocomplete();
      }
    });
  }

  deletePark() {
    if (confirm(`Are you sure want to delete "${this.viewPark.name}"?`)) {
      const url = `${this.urlHelper.getPrefix()}/parks/${this.controllerId}`;

      this.http.delete(url).subscribe(res => {
        this.router.navigate([`/controllers`]);
      }, (err => {
        if (err.hasOwnProperty('error')) {
          this.error = err.error.error;
        } else {
          this.error = 'Something go wrong. Please try later.';
        }
      }));
    }
  }

  private clientNames(clients) {
    const names = [];

    clients.forEach(client => {
      if (typeof client !== 'undefined' && client !== null && client.hasOwnProperty('attributes')
        && client.attributes.hasOwnProperty('company_name')) {
        names.push(client.attributes.company_name);
      }
    });

    return names;
  }

  private initView(data, location, clients) {
    this.viewPark.name = data.data.attributes.name;
    this.viewPark.address = location.attributes ? location.attributes.address : '';
    this.viewPark.projectId = data.data.attributes.project_id;
    this.viewPark.installation_type = data.data.attributes.installation_type || 'FT';
    this.viewPark.iccid = data.data.attributes.iccid;
    this.viewPark.active = data.data.attributes.active;
    this.viewPark.is_provisioned = data.data.attributes.is_provisioned;
    this.viewPark.clientNames = this.clientNames(clients);
    this.viewPark.parkId = data.data.attributes.park_id ? (data.data.attributes.park_id.slice(0, 10) + '...') : 'N/A';
    this.viewPark.clientId = data.data.relationships.client.data ? data.data.relationships.client.data.id : null;
  }

  runAutocomplete() {
    this.changeDetector.detectChanges();
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.addressAutocompleteEl.nativeElement, {
        types: ['address']
      });

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.formatted_address === undefined || place.formatted_address === null) {
            return;
          }

          this.coords.lat = place.geometry.location.lat();
          this.coords.lon = place.geometry.location.lng();
          this.zoom = 12;

          this.addControllerForm.patchValue({
            address: place.formatted_address,
          });
        });
      });
    });
  }

  onCloseCancel() {
    this.mode = 'view';
  }

  onSubmit({value, valid}) {
    if (valid) {
      this.updateRunning = true;

      this.save(value).subscribe((res: { data: any, meta: any, included: any }) => {
        this.updateRunning = false;

        if (!this.controllerId) {
          this.openDialog(res.meta.url);
          this.router.navigate([`/controllers/${res.data.id}`]);
        } else {
          this.success = 'The controller was updated.';
          this.mode = 'view';

          let location: any = {};
          const clients = [];

          res.included.forEach((inc) => {
            if (inc.type === 'Location') {
              location = inc;
            }
            if (inc.type === 'Clients') {
              clients.push(inc);
            }
          });


          this.initView(res, location, clients);
        }
      }, (err) => {
        this.updateRunning = false;

        if (err.hasOwnProperty('error')) {
          this.error = err.error.error;
        } else {
          this.error = 'Something go wrong. Please try later.';
        }
      });
    }
  }

  save(data) {
    const body = {
      data: {
        type: 'Parks',
        attributes: {
          project_id: data.projectId,
          name: data.name,
          address: data.address,
          installation_type: data.installation_type,
          iccid: data.iccid
        },
        relationships: {
          client: {
            data: {
              type: 'Clients',
              id: data.clientId || null
            }
          }
        }
      }
    };

    if (this.controllerId) {
      return this.http.put(this.prepareParkUrl(), body);
    } else {
      return this.http.post(this.prepareParksUrl(), body);
    }
  }

  openToggleLedDialog() {
    const toggleLedDialogRef = this.provisionDialog.open(ToggleLedDialogComponent, {
      width: '600px',
      data: {controllerId: this.controllerId, parkId: this.parkId, url: this.prepareToggleLedUrl()}
    });

    toggleLedDialogRef.afterClosed().subscribe((result: any) => {
      if (typeof result !== 'undefined' && result.hasOwnProperty('success')) {
        if (result.success) {
          if (result.hasOwnProperty('message')) {
            this.success = result.message;
          }
        } else {

        }
      }
    });
  }

  openProvisionDialog() {
    const provisionDialogRef = this.provisionDialog.open(ProvisionControllerDialogComponent, {
      width: '600px',
      data: {controllerId: this.controllerId, parkId: this.parkId, url: this.prepareProvisionUrl()}
    });

    provisionDialogRef.afterClosed().subscribe((result: any) => {
      if (typeof result !== 'undefined' && result.hasOwnProperty('success')) {
        if (result.success) {
          if (result.hasOwnProperty('message')) {
            this.success = result.message;
          }
        } else {

        }
      }
    });
  }

  openUpdateDialog() {
    const updateDialogRef = this.updateDialog.open(UpdateControllerDialogComponent, {
      width: '600px',
      data: {controllerId: this.controllerId, parkId: this.parkId}
    });

    updateDialogRef.afterClosed().subscribe((result: any) => {
      if (typeof result !== 'undefined' && result.hasOwnProperty('success')) {
        if (result.success) {
          if (result.hasOwnProperty('message')) {
            this.success = result.message;
          }
        } else {

        }
      }
    });
  }

  toEditMode() {
    this.mode = 'create';
    this.runAutocomplete();
  }

  openDialog(link): void {
    const dialogRef = this.dialog.open(ControllerDialogComponent, {
      width: '400px',
      data: {link: link}
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (typeof result !== 'undefined' && result.hasOwnProperty('success')) {
        if (result.success) {
          if (result.hasOwnProperty('message')) {
            this.success = result.message;
          }
        } else {

        }
      }
    });
  }

  toggleConnection() {
    const body = {
      data: {
        type: 'Parks',
        id: this.controllerId,
        attributes: {
          active: !this.viewPark.active
        }
      }
    };

    this.patchRunning = true;

    this.http.patch(this.prepareParkUrl(), body).subscribe(
      (res: any) => {
        this.viewPark.active = res.data.attributes.active;
        this.patchRunning = false;
      }, (err) => {
        this.patchRunning = false;
      }, () => {
        this.patchRunning = false;
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/controller/controller.component.ts